import React from 'react';
import { states } from '../StatePicker';
import { MultiSelectFilter } from './MultiSelectFilter';

const STATE_OPTIONS = states.map((state) => ({
  label: state.name,
  value: state.abbreviation,
}));

/** State filter (multi-select). Writes the `state` filter key. */
export const StateFilter = ({ filter, handleFilterChange }) => (
  <MultiSelectFilter
    label="State"
    options={STATE_OPTIONS}
    value={filter?.state}
    onChange={(value) => handleFilterChange('state', value)}
  />
);

export default StateFilter;
